"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var LoginForm_styles_1 = __importDefault(require("./LoginForm.styles"));
var InputText_styles_1 = __importDefault(require("../../atoms/InputText/InputText.styles"));
var Button_1 = __importDefault(require("../../atoms/Button/Button"));
var axios_1 = __importDefault(require("axios"));
var loginState_1 = require("../../../types/loginState");
var LoginForm = function (props) {
    var _a = react_1.useState(''), email = _a[0], setEmail = _a[1];
    var _b = react_1.useState(''), password = _b[0], setPassword = _b[1];
    var _c = react_1.useState(false), authError = _c[0], setAuthError = _c[1];
    var _d = react_1.useState(false), unknownError = _d[0], setUnknownError = _d[1];
    var handleSubmit = function (e) {
        e.preventDefault();
        axios_1.default.get('/sanctum/csrf-cookie')
            .then(function () {
            axios_1.default.post('/login', {
                email: email,
                password: password
            })
                .then(function (response) {
                if (response.status === 204) {
                    props.login();
                }
            })
                .catch(function (error) {
                if (error.response && error.response.status === 422) {
                    setAuthError(true);
                }
                else {
                    setUnknownError(true);
                    console.error(error);
                }
            });
        });
    };
    react_1.useEffect(function () {
        var body = document.querySelector('body');
        if (body) {
            body.classList.add('login'); // also handles fade-in animation and hides app navigation
        }
        if (props.loggedIn === loginState_1.LOGGEDIN && body) {
            body.classList.remove('login');
        }
    }, [props.loggedIn]);
    if (props.loggedIn === loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: '/' });
    }
    return (react_1.default.createElement(LoginForm_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "login" },
                    react_1.default.createElement("div", { className: "form__container" },
                        react_1.default.createElement("h1", { className: "form__title" }, "Inloggen bij de aanbiedersomgeving"),
                        react_1.default.createElement("form", { className: "form", onSubmit: handleSubmit },
                            react_1.default.createElement(InputText_styles_1.default, null,
                                react_1.default.createElement("label", { htmlFor: "email" }, "E-mail adres"),
                                react_1.default.createElement("input", { id: "email", type: "email", placeholder: "E-mail adres", value: email, onChange: function (e) { return setEmail(e.target.value); }, required: true })),
                            react_1.default.createElement(InputText_styles_1.default, null,
                                react_1.default.createElement("label", { htmlFor: "password" }, "Wachtwoord"),
                                react_1.default.createElement("input", { id: "password", type: "password", placeholder: "Wachtwoord", value: password, onChange: function (e) { return setPassword(e.target.value); }, required: true })),
                            authError && react_1.default.createElement("p", { className: "form__error" }, "Je gebruikersnaam of wachtwoord is niet correct. Probeer het opnieuw."),
                            unknownError && react_1.default.createElement("p", { className: "form__error" }, "Er ging iets mis tijdens het versturen. Probeer het opnieuw."),
                            react_1.default.createElement(Button_1.default, { className: "form__button secondary", type: "submit" },
                                react_1.default.createElement("span", null,
                                    "Inloggen",
                                    react_1.default.createElement("svg", { className: "icon icon--arrow-right icon--link" },
                                        react_1.default.createElement("use", { xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" })))))),
                    react_1.default.createElement("div", { className: "login__aside" },
                        react_1.default.createElement("p", { className: "login__aside-title" }, "Nog geen account?"),
                        react_1.default.createElement("a", { className: "login__aside-link", href: "https://www.sportbedrijfrotterdam.nl" },
                            "Klik hier voor meer informatie over de voordelen en aanmelden ",
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("svg", { className: "icon icon--arrow-right icon--link" },
                                react_1.default.createElement("use", { xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" }))))))),
        react_1.default.createElement("div", { className: "login__decoration" },
            react_1.default.createElement("img", { className: "login__decoration--green", src: "/dist/assets/img/svg/green.svg" }),
            react_1.default.createElement("img", { className: "login__decoration--yellow", src: "/dist/assets/img/svg/yellow.svg" }),
            react_1.default.createElement("img", { className: "login__decoration--red", src: "/dist/assets/img/svg/red.svg" }),
            react_1.default.createElement("img", { className: "login__decoration--blue", src: "/dist/assets/img/svg/blue.svg" }))));
};
exports.default = LoginForm;
